// libs
import React from 'react';
import PropTypes from 'prop-types';

// component
import Image from '../../../tools/image/Image';

// Placeholder
import placeHolder from '../../../../../assets/images/placeholder-unavailable.svg';

function CardImage(props) {
  const { title, image, resourceType, actionComponent: ActionComponent } = props;
  return (
    <div className="card__image">
      <ActionComponent {...props}>
        {resourceType === 'video' &&
          <div className="card__image__play">
            <span />
          </div>
        }
        <Image
          className="card__img"
          alt={title}
          mediaUrl={image || placeHolder}
          key={`cardImg-${title}`}
        />
        <div
          className="card__img__blur"
          style={{ backgroundImage: `url(${image})` }}
          key={`cardImg-${title}-blur`}
        />
      </ActionComponent>
    </div>
  );
}

CardImage.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  resourceType: PropTypes.string,
  actionComponent: PropTypes.func.isRequired,
};
CardImage.defaultProps = {
  resourceType: null,
  image: null,
};
CardImage.contextTypes = {
  t: PropTypes.func,
};

export default CardImage;



// WEBPACK FOOTER //
// ./src/app/components/cards/card/parts/CardImage.js